import styled from "styled-components";
import { Flex } from "../../components/Flex";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";
import { Link, useRouteMatch, Route } from "react-router-dom";
import { FaUser, FaCog, FaPalette, FaMoneyBill, FaBell } from "react-icons/fa";
import { Box } from "../../components/Box";
import { Text } from "../../components/Text";
import { ThemeSettings } from "./ThemeSettings";
import GeneralSettings from "./GeneralSettings";
import SubscriptionSettings from "./SubscriptionSettings";
import AccountSettings from "./AccountSettings";
import NotificationSettings from "./NotificationSettings";

const Sidebar = styled.aside<SpaceProps & LayoutProps>`
  background-color: ${(props) => props.theme.colors.grey1};
  flex-shrink: 0;
  flex-grow: 0;
  ${layout};
  ${space};
`;

const SidebarLink = styled(Link)<{ active: number } & SpaceProps>`
  color: ${(props) =>
    props.active ? props.theme.colors.primary : props.theme.colors.body};
  font-weight: 600;
  display: flex;
  align-items: center;
  svg {
    margin-right: 12px;
  }

  ${space};
`;

const SidebarItem = ({
  to,
  exact,
  children
}: {
  to: string;
  exact: boolean;
  children: React.ReactNode;
}) => {
  const match = useRouteMatch({ path: to, exact: exact });

  return (
    <SidebarLink to={to} active={match != null ? 1 : 0} mb={2}>
      {children}
    </SidebarLink>
  );
};

const SettingsPage = () => {
  return (
    <Flex flexDirection={["column", "row"]} height="100vh">
      <Sidebar width={["100%", "300px"]} pt={[3, 6]} pb={2} pl={5} pr={5}>
        <SidebarItem to="/settings" exact>
          <FaUser /> Account
        </SidebarItem>
        <SidebarItem to="/settings/general" exact>
          <FaCog /> General
        </SidebarItem>
        <SidebarItem to="/settings/theme" exact>
          <FaPalette /> Theme
        </SidebarItem>
        <SidebarItem to="/settings/subscription" exact>
          <FaMoneyBill /> Subscription
        </SidebarItem>
        <SidebarItem to="/settings/notifications" exact>
          <FaBell /> Notifications
        </SidebarItem>
      </Sidebar>
      <Box p={5} pt={6} style={{ flex: 1 }}>
        <Route path="/settings" exact component={AccountSettings} />
        <Route path="/settings/general" exact component={GeneralSettings} />
        <Route path="/settings/theme" exact component={ThemeSettings} />
        <Route
          path="/settings/subscription"
          exact
          component={SubscriptionSettings}
        />
        <Route
          path="/settings/notifications"
          exact
          component={NotificationSettings}
        />
      </Box>
    </Flex>
  );
};

export const SettingsHeading = (props: any): JSX.Element => (
  <Text fontWeight={600} mb={2} {...props} />
);

export default SettingsPage;
